/* Ignite Sales */

const Screens = {
  CONTACT:    'contact',
  LOCATION:   'location',
  CALENDAR:   'schedule',
  SUCCESS:    'successful',
  FAIL:       'failed',
};

export default Screens;


/** WEBPACK FOOTER **
 ** ./src/main/js/contactMe/constants/Screens.js
 **/